import { useEffect } from 'react';
import { useBrandsOperations } from './useBrandsOperations';
import { useShowFavouriteBrands } from './useShowFavouriteBrands';

export const useInitFavouriteBrands = () => {
  const { getFavouriteBrands } = useBrandsOperations();
  const showFavouriteBrands = useShowFavouriteBrands();

  useEffect(() => {
    if (showFavouriteBrands) {
      getFavouriteBrands();
    }
  // eslint-disable-next-line
  }, [showFavouriteBrands]);
};
